import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import EditableTextArea from 'components/forms/editableTextArea';

class NewPlasterText extends React.Component {
  static defaultProps = {
    plasterText: '',
  };

  static propTypes = {
    dataChanged: PropTypes.func.isRequired,
    plasterText: PropTypes.string,
    editMode: PropTypes.bool,
  };

  render() {
    const maxNewPlasterLength = 200;
    let {dataChanged, plasterText, intl, editMode} = this.props;
    let charactersUsed = (plasterText ? plasterText.length : 0) + '/' + maxNewPlasterLength + ' ' + intl.formatMessage({id: 'footer.characters.used'});

    return <div className='container-fluid new-plaster'>
      <div className='row'>
        <label>{intl.formatMessage({id: 'footer.new.plaster.startup'})}</label>
      </div>

      <div className='row'>
        <div className='col-xs-12'>
        <EditableTextArea
          editMode={editMode}
          dataKey='newPlasterText'
          onChange={dataChanged}
          value={plasterText}
          placeholder={intl.formatMessage({id: 'footer.new.plaster.startup'})} 
          footerText={editMode ? charactersUsed : null} 
          maxLength={maxNewPlasterLength}/>
        </div>
      </div>
    </div>;
  }
}

export default injectIntl(NewPlasterText);
